import { ConcreteEncodable } from "./ConcreteEncodable";

import { UserProfileChangeEventImplEncoder } from "../../encoder/UserProfileChangeEventImplEncoder";

import * as CubiqTS from "../../index";
import { UserProfileChangeEvent } from "../UserProfileChangeEvent";

export class UserProfileChangeEventImpl
  extends ConcreteEncodable
  implements UserProfileChangeEvent
{
  public static enType: string = "com.bcdfx.model.UserProfileChangeEventImpl";

  /*FID=1*/
  public userCd: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = UserProfileChangeEventImplEncoder.Instance;
    this.setEncodableType(UserProfileChangeEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "UserProfileChangeEventImpl[" + "userCd=" + this.userCd + "messageId=" + this.messageId + "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
